export default function GameboardHeader( props: any ) {

    return (
        <div id="gameboard-header">
            <h1>{props.strategyName}</h1>
        </div>
    )
    
}